/** Display names for Pro Page layouts in the Add Feature Section picker. */
export const MARKETING_PRO_LAYOUT_PICKER_COPY = {
  HERO: {
    label: 'Hero Layout 2',
    description: 'Large hero section with headline, supporting text, CTA and device preview image'
  },
  FOUR_CARD: {
    label: 'Feature Cards Grid',
    description: 'Four feature cards with image, title and short description'
  },
  SHOWCASE_SLIDER: {
    label: 'Showcase Carousel',
    description: 'Carousel section with heading, mockups and pagination dots'
  },
  COMPARISON_TABLE: {
    label: 'Feature Comparison Table',
    description: 'Comparison matrix with heading, description and TopFan-vs-others rows'
  },
  CREATOR_GRID: {
    label: 'Cards Grid',
    description: 'Heading, subtitle and 4×2 grid of creator cards with CTA'
  }
} as const;
